(() => {
  window.BEK_SG23_DATA = {
    version: 'M11.2.4-SG23-DATA-1',
    source: 'VD Slide Glas 23 - SG23 Preisliste ab 01.08.2026',
    pricing: {
      vatPct: 19,
      dealerDiscountPct: 50,
      targetMarginPct: 40,
      logisticsReserveNet: 160,
      minimumCustomerGross: 1490,
      roundingMode: 'x090',
      satinatoGrossPerSqm: 69,
      specialColorGross: 649,
      specialColorMinimumNetList: 310,
      accessories: {
        LOCK: { label: 'SG23 Schloss', netList: 239, customerGross: 490 },
        HOOK: { label: 'Hakenverschluss', netList: 72, customerGross: 149 },
        EXTRA_GRIP: { label: 'Zusätzlicher Rundgriff', netList: 32, customerGross: 69 }
      }
    },
    standardColors: ['RAL 7016', 'RAL 9006', 'RAL 9007', 'RAL 9010'],
    heightBands: [1500, 2000, 2500],
    layouts: {
      '3-2': {
        label: '3-spurig · 2-türig', rails: 3, doors: 2, widthBands: [1500,2000,2500,3000], specialColorNetList: 140,
        pricesNetList: {
          '1500x1500':1018.58,'2000x1500':1137.76,'2500x1500':1317.95,'3000x1500':1437.13,
          '1500x2000':1095.55,'2000x2000':1275.74,'2500x2000':1445.92,'3000x2000':1626.11,
          '1500x2500':1223.52,'2000x2500':1403.71,'2500x2500':1644.89,'3000x2500':1825.08
        }
      },
      '3-3': {
        label: '3-spurig · 3-türig', rails: 3, doors: 3, widthBands: [2500,3000,3500,4000], specialColorNetList: 150,
        pricesNetList: {
          '2500x1500':1376.83,'3000x1500':1496.02,'3500x1500':1676.20,'4000x1500':1795.39,
          '2500x2000':1514.81,'3000x2000':1684.99,'3500x2000':1865.18,'4000x2000':2045.36,
          '2500x2500':1703.78,'3000x2500':1883.97,'3500x2500':2115.15,'4000x2500':2295.34
        }
      },
      '3-4': {
        label: '3-spurig · 4-türig', rails: 3, doors: 4, widthBands: [3000,3500,4000,4500,5000], specialColorNetList: 170,
        pricesNetList: {
          '3000x1500':1740.49,'3500x1500':1920.67,'4000x1500':2039.86,'4500x1500':2220.04,'5000x1500':2339.23,
          '3000x2000':1939.46,'3500x2000':2109.65,'4000x2000':2289.83,'4500x2000':2470.02,'5000x2000':2650.20,
          '3000x2500':2128.43,'3500x2500':2369.62,'4000x2500':2539.80,'4500x2500':2780.99,'5000x2500':2961.18
        }
      },
      '3-6': {
        label: '3-spurig · 6-türig', rails: 3, doors: 6, widthBands: [4000,4500,5000,5500,6000,6500], specialColorNetList: 190,
        pricesNetList: {
          '4000x1500':2167.63,'4500x1500':2337.81,'5000x1500':2467.00,'5500x1500':2637.19,'6000x1500':2756.37,'6500x1500':2936.56,
          '4000x2000':2417.60,'4500x2000':2597.79,'5000x2000':2767.97,'5500x2000':2948.16,'6000x2000':3128.34,'6500x2000':3308.53,
          '4000x2500':2667.58,'4500x2500':2898.76,'5000x2500':3078.95,'5500x2500':3320.13,'6000x2500':3500.32,'6500x2500':3731.50
        }
      },
      '4-4': {
        label: '4-spurig · 4-türig', rails: 4, doors: 4, widthBands: [3000,3500,4000,4500,5000], specialColorNetList: 180,
        pricesNetList: {
          '3000x1500':1669.05,'3500x1500':1865.26,'4000x1500':2000.47,'4500x1500':2186.68,'5000x1500':2321.89,
          '3000x2000':1868.02,'3500x2000':2054.23,'4000x2000':2250.44,'4500x2000':2446.65,'5000x2000':2632.86,
          '3000x2500':2056.99,'3500x2500':2304.20,'4000x2500':2500.41,'4500x2500':2547.62,'5000x2500':2943.83
        }
      },
      '5-5': {
        label: '5-spurig · 5-türig', rails: 5, doors: 5, widthBands: [4000,4500,5000,5500,6000], specialColorNetList: 210,
        pricesNetList: {
          '4000x1500':2174.68,'4500x1500':2375.55,'5000x1500':2325.43,'5500x1500':2726.31,'6000x1500':2876.18,
          '4000x2000':2424.65,'4500x2000':2625.53,'5000x2000':2836.40,'5500x2000':3037.28,'6000x2000':3238.15,
          '4000x2500':2674.62,'4500x2500':2936.50,'5000x2500':3147.38,'5500x2500':3409.25,'6000x2500':3610.13
        }
      }
    },
    notes: [
      '10 mm ESG klar ist im Anlagenpreis enthalten.',
      '10 mm ESG Satinato: VD-Aufpreis 28,00 € netto pro m²; BEK Verkauf 69 € brutto pro m².',
      'Zwei Griffe sind laut VD-Preisliste inklusive.',
      'Außenanlagen maximal 2.450 mm Höhe; die Preisstaffel wird bis 2.500 mm aufgerundet.',
      'Preislistenbreiten werden in 500-mm-Schritten auf die nächste passende Stufe aufgerundet.',
      'Standardfarben: RAL 7016, 9006, 9007, 9010.',
      'Sonderfarbe: BEK Verkauf +649 €; VD Mindestbetrag 310 € netto pro Farbcode, ohne Rabatt.',
      'Automatik wählt die günstigste passende VD-Aufteilung. Die gewünschte Schienen-/Türteilung kann manuell gewählt werden.'
    ]
  };
})();
